import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useNotification } from 'src/hooks/useNotification'
import { IIcon } from 'src/type'
import notificationAnimationIcon from 'public/animations/Notification.json'
import Lottie from 'lottie-react'
const NotificationIcon = ({ className, extraClassName }: IIcon) => {
  const [badgeClass, setBadgeClass] = useState('w-4 h-4 -top-[5px] -right-1.5') // Default width
  const { notificationUnread, hasNewNotification } = useNotification()

  useEffect(() => {
    if (notificationUnread > 9) {
      setBadgeClass('w-6 h-6 -top-3.5 -right-3.5')
    } else {
      setBadgeClass('w-4 h-4 -top-[5px] -right-1.5') // Default width for single digits
    }
  }, [notificationUnread])
  const animationClass = clsx(`before-icon w-6 h-6`)
  return (
    <div className="relative">
      {hasNewNotification ? (
        <Lottie
          animationData={notificationAnimationIcon}
          loop
          autoplay
          className={animationClass}
        />
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={className}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1.25C7.71983 1.25 4.25004 4.71979 4.25004 9V9.7041C4.25004 10.401 4.04375 11.0824 3.65717 11.6622L2.50856 13.3851C1.17547 15.3848 2.19318 18.1028 4.51177 18.7351C5.26738 18.9412 6.02937 19.1155 6.79578 19.2581L6.79768 19.2632C7.56667 21.3151 9.62198 22.75 12 22.75C14.378 22.75 16.4333 21.3151 17.2023 19.2632L17.2042 19.2581C17.9706 19.1155 18.7327 18.9412 19.4883 18.7351C21.8069 18.1028 22.8246 15.3848 21.4915 13.3851L20.3429 11.6622C19.9563 11.0824 19.75 10.401 19.75 9.7041V9C19.75 4.71979 16.2802 1.25 12 1.25ZM15.3764 19.537C13.1335 19.805 10.8664 19.8049 8.62349 19.5369C9.33444 20.5585 10.571 21.25 12 21.25C13.4289 21.25 14.6655 20.5585 15.3764 19.537ZM5.75004 9C5.75004 5.54822 8.54826 2.75 12 2.75C15.4518 2.75 18.25 5.54822 18.25 9V9.7041C18.25 10.6972 18.544 11.668 19.0948 12.4943L20.2434 14.2172C21.0086 15.3649 20.4245 16.925 19.0936 17.288C14.4494 18.5546 9.5507 18.5546 4.90644 17.288C3.57561 16.925 2.99147 15.3649 3.75664 14.2172L4.90524 12.4943C5.45609 11.668 5.75004 10.6972 5.75004 9.7041V9Z"
            fill="currentColor"
          />
        </svg>
      )}

      {notificationUnread > 0 && (
        <span
          className={clsx(
            'absolute flex aspect-1 items-center justify-center rounded-full bg-[#D35563] text-xs text-white',
            badgeClass,
            extraClassName,
          )}
        >
          {notificationUnread > 99 ? '99+' : notificationUnread}
        </span>
      )}
    </div>
  )
}

export default NotificationIcon
